import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-custom-snack-bar',
  templateUrl: './custom-snack-bar.component.html',
  styleUrls: ['./custom-snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, DatePipe],
})
export class CustomSnackBarComponent implements OnInit {
  data = inject(MAT_SNACK_BAR_DATA);
  snackBar = inject(MatSnackBar);

  now: number;

  ngOnInit() {
    // Snackbars are transient; capture the timestamp once instead of a
    // runaway 1ms interval that pinned CPU and leaked (never cleared).
    this.now = Date.now();
  }
}
